import React, { useState } from "react";
import { Users } from "lucide-react";
import { useLang } from "../LanguageContext";
import { team } from "../data/team";
import { TeamMemberModal } from "../components/TeamMemberModal";

export default function Team() {
  const { t, lang } = useLang();
  const [active, setActive] = useState(null);

  return (
    <div data-testid="page-team">
      <section className="container-page pt-16 sm:pt-24 pb-10">
        <p className="eyebrow mb-4">{t("team.eyebrow")}</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-ink max-w-3xl leading-tight">
          {t("team.title")}
        </h1>
        <p className="mt-6 text-lg text-ink-muted leading-relaxed max-w-2xl">
          {t("team.intro")}
        </p>
        <div className="mt-8 rounded-[1.25rem] border border-forest/15 bg-forest/5 p-5 sm:p-6 max-w-2xl" data-testid="team-snapshot-blurb">
          <p className="text-xs uppercase tracking-[0.14em] text-forest-dark font-medium mb-2">
            {t("team.snapshot_label")}
          </p>
          <p className="text-ink-muted leading-relaxed text-sm sm:text-base">
            {t("team.snapshot_text")}
          </p>
        </div>
      </section>

      <section className="container-page pb-24">
        {team.length === 0 ? (
          <div className="card-soft p-12 sm:p-16 max-w-2xl mx-auto text-center" data-testid="team-empty">
            <div className="w-14 h-14 rounded-2xl bg-forest-light grid place-items-center mx-auto mb-6 text-forest">
              <Users size={26} strokeWidth={1.6} />
            </div>
            <p className="text-ink-muted leading-relaxed">{t("team.empty")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {team.map((member) => {
              const role = lang === "fr" ? member.role_fr : member.role_en;
              return (
                <button
                  key={member.id}
                  type="button"
                  onClick={() => setActive(member)}
                  className="group text-left card-soft overflow-hidden p-3 sm:p-4 transition-transform hover:-translate-y-1"
                  data-testid={`team-card-${member.id}`}
                >
                  <div className="rounded-[1rem] overflow-hidden bg-white">
                    <img
                      src={member.interestsImage}
                      alt={member.name}
                      className="w-full h-auto block transition-transform duration-300 group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                  </div>
                  <div className="pt-4 px-1">
                    <p className="font-heading text-lg text-ink font-medium">{member.name}</p>
                    <p className="text-sm text-ink-muted mt-0.5">{role}</p>
                    <span className="inline-block mt-3 text-xs font-medium text-forest underline underline-offset-4">
                      {t("team.view_sheet")}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </section>

      <TeamMemberModal member={active} open={!!active} onOpenChange={(v) => !v && setActive(null)} />
    </div>
  );
}
